import confirmContentPagesRemovalOperation from 'editor/src/store/design/operation/spreadManipulation/confirmContentPagesRemovalOperation';
import { DesignDimensions } from 'editor/src/store/design/types';
import { pageCountDropLoss } from 'editor/src/store/design/util/pageCountSwitchLoss';
import type { Thunk } from 'editor/src/store/hooks';
import isPageCountOptionsEnabled from 'editor/src/store/hostSettings/selector/isPageCountOptionsEnabled';

import resetPageCountOperation from './resetPageCountOperation';

// A smaller page count leaves the trailing pages behind, so one that would take the user's content
// asks first, as deleting those pages does.
const resetPageCountWithConfirmationOperation =
  (pageCount: number, dimensions: DesignDimensions | undefined, productUid: string, onCancel?: () => void): Thunk =>
  (dispatch, getState) => {
    const apply = () => dispatch(resetPageCountOperation(pageCount, dimensions, productUid));

    if (!isPageCountOptionsEnabled(getState())) {
      apply();
      return;
    }

    const { pages, holdsContent } = pageCountDropLoss(getState(), pageCount);
    if (holdsContent) {
      dispatch(confirmContentPagesRemovalOperation(pages, apply, onCancel));
      return;
    }
    apply();
  };

export default resetPageCountWithConfirmationOperation;
